import { render, staticRenderFns } from "./checkboxList.vue?vue&type=template&id=7147f52d&scoped=true&"
import script from "./checkboxList.vue?vue&type=script&lang=js&"
export * from "./checkboxList.vue?vue&type=script&lang=js&"
import style0 from "./checkboxList.vue?vue&type=style&index=0&id=7147f52d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7147f52d",
  null
  
)

export default component.exports